export default __webpack_public_path__ + "static/people-centric-26805baf1cb6cc480b9a0cda1ba84eeb.webp";